import axios from "../api/axios";
import {RESET_PASSWORD_URL} from "../utils/constants";

export async function resetPasswordService(data: any): Promise<any> {
    const response = await axios.post(RESET_PASSWORD_URL, data);
    return response.data;
}
